// project import
import pages from './pages';
import dashboard from './dashboard';
import utilities from './utilities';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //
//pages,
const menuItems = {
    items: [dashboard,  utilities, support]
};

export default menuItems;
